import { Injectable, Output, EventEmitter  } from "@angular/core";
import { LocalStoreService } from "./local-store.service";
import { Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthorizationService } from "./authorization.service";
import { environment } from "src/environments/environment";
import swal from 'sweetalert2';

@Injectable({
  providedIn: "root"
})
export class AuthService {
  @Output() userInfoChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(private store: LocalStoreService, private router: Router,
    private http: HttpClient,
    private toastr: ToastrService,
    private authorizationService: AuthorizationService) {
    //this.checkAuth();
  }



  getStoredUserInfo() {
    return this.store.getItem('user_info');
  }

  getUser() {
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/settings/getmemberinfo`, {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      }).subscribe((res: any) => {
        this.store.removeItem('user_info');
        this.store.setItem('user_info', res.basicInfo);
        this.userInfoChange.emit(res.basicInfo);
        resolve(res);
      });
    });
  }

  signin(credentials) {
    return new Promise(resolve => {
      this.http.post(`${environment.apiUrl}/auth/login`, credentials, {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      }).subscribe((response: any) => {
        let token = response.tokens.actionToken;
        let refreshToken = response.tokens.refreshToken;
        this.store.setRawItem('access_token', token);
        this.store.setRawItem('refresh_token', refreshToken);
        this.store.setItem('user_info', response.basicInfo);

        //console.log(response.basicInfo);
        //this.getUserInfo.emit(response.basicInfo);
        //console.log(response.basicInfo.status);
        if(response.basicInfo.status === 3)
          swal.fire('Account Flagged','Your account has been flagged due to suspecious payment activity. Please contact us by sending email to info@boombinere.com','warning');

        this.toastr.clear();
        resolve(true);
      }, err => {
        console.log(err);
        this.toastr.error(err.error.title, 'Error!', { progressBar: true });
        resolve(false);
      });
    });
  }

  signout() {
    //this.authenticated = false;
    this.removeSessionValues();
    this.router.navigateByUrl("/sessions/signin");
  }

  removeSessionValues() {
    this.store.removeItem('access_token');
    this.store.removeItem('refresh_token');
    this.store.removeItem('user_info');
  }

  register(data) {
    return new Promise(resolve => {
      this.http.post(`${environment.apiUrl}/auth/register`, data, {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      }).subscribe(response => {
        resolve(true);
      }, err => {
        console.log(err);
        this.toastr.error(err.error.title, 'Error!', { progressBar: true });
        resolve(false);
      });
    });
  }

  confirm(key) {
    return new Promise(resolve => {
      this.http.post(`${environment.apiUrl}/auth/confirm/` + key, {}, {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      }).subscribe(response => {
        this.toastr.success('Account is verified successfully', 'Welcome', { disableTimeOut: true, closeButton: true });
        resolve(true);
      }, err => {
        console.log(err);
        this.toastr.error(err.error.title, 'Error!', { disableTimeOut: true, closeButton: true });
        resolve(false);
      });
    });
  }

  forgotPassword(data) {
    return new Promise(resolve => {
      this.http.post(`${environment.apiUrl}/auth/resetpassword/`, data, {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      }).subscribe(response => {
        this.toastr.success('Password reset instructions sent to your email address!', 'Done', { disableTimeOut: true, closeButton: true });
        resolve(true);
      }, err => {
        console.log(err);
        this.toastr.error(err.error.title, 'Error!', { progressBar: true });
        resolve(false);
      });
    });
  }

  confirmPassword(key) {
    return new Promise(resolve => {
      this.http.post(`${environment.apiUrl}/auth/confirmpassword/${key}`, {}, {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      }).subscribe(response => {
        //this.toastr.success('Account is verified successfully', 'Welcome', { disableTimeOut: true, closeButton:true });
        resolve(true);
      }, err => {
        console.log(err);
        this.toastr.error(err.error.title, 'Error!', { disableTimeOut: true, closeButton: true });
        resolve(false);
      });
    });
  }

  changePassword(key, data) {
    return new Promise(resolve => {
      this.http.post(`${environment.apiUrl}/auth/changepassword/${key}`, data, {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      }).subscribe(response => {
        this.toastr.success('Your password has been changed succesfully!', 'Done', { disableTimeOut: true, closeButton: true });
        resolve(true);
      }, err => {
        console.log(err);
        this.toastr.error(err.error.title, 'Error!', { progressBar: true });
        resolve(false);
      });
    });
  }

  confirmIntegration(key) {
    return new Promise(resolve => {
      this.http.post(`${environment.apiUrl}/auth/confirmintegration/` + key, {}, {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      }).subscribe(response => {
        this.toastr.success('Your Account is linked with your Boombeene account successfully', 'Account Linked', { disableTimeOut: true, closeButton: true });
        resolve(true);
      }, err => {
        console.log(err);
        this.toastr.error(err.error.title, 'Error!', { disableTimeOut: true, closeButton: true });
        resolve(false);
      });
    });
  }
}
